import { fetchApi } from "../fetchInstance";

// eslint-disable-next-line no-unused-vars
import * as Types from "./types";
import {
  fetchPaginatedMemoriesUrl,
  createMemoryUrl,
  editMemoryUrl,
  getMemoryByIdUrl,
  deleteMemoryUrl,
} from "./url";

export const memoriesApi = {
  /**
   * @param {Types.FetchMemoryDto} obj
   */
  getMemoriesPaginated: (obj) => {
    return fetchApi.get(fetchPaginatedMemoriesUrl(obj), undefined, obj.signal);
  },
  getMemoryById: (id) => fetchApi.get(getMemoryByIdUrl(id)),
  createMemory: (data) => fetchApi.post(createMemoryUrl(), data),
  editMemoryById: (id, data) => fetchApi.patch(editMemoryUrl(id), data),
  deleteMemory: (id) => fetchApi.delete(deleteMemoryUrl(id)),
};
